import React, { useEffect, useState } from "react";
import { Container, List } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { states } from "../../../services/states";
import HeaderPublic from "../../../components/headerPublic";
import { useQuery } from "../../../hooks/Location";
import { Button, Modal, Pagination, Select, Spin } from "antd";
import { Message } from "../../../GlobalStyles";
import userPhoto from "../../../images/user.png";

export default function Credentials() {
  const navigate = useNavigate();

  const query = useQuery();

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(parseInt(query.get("page")) || 0);
  const [credentials, setCredentials] = useState([]);
  const [credential, setCredential] = useState({});
  const [visibleModal, setVisibleModal] = useState(false);
  const [credentialsTotal, setCredentialsTotal] = useState(0);
  const [state, setState] = useState(query.get("state") || "");
  const [city, setCity] = useState(query.get("city") || "");
  const [service, setService] = useState(query.get("service") || "");
  const [cities, setCities] = useState([]);

  useEffect(() => {
    setPage(parseInt(query.get("page")) || 0);
    let state = query.get("state") || "";
    setState(state);
    if (state) {
      setCities(
        states.filter((item) => {
          return item.sigla == state;
        })[0].cidades,
      );
    }
    setCity(query.get("city") || "");
    setService(query.get("service") || "");
    listCredentials();
  }, [window.location.href, page]);

  async function listCredentials() {
    setLoading(true);
    let filter = `?page=${page}`;
    if (state) {
      filter += `&state=${state}`;
      if (city) {
        filter += `&city=${city}`;
      }
    }
    if (service) {
      filter += `&service=${service}`;
    }
    await api
      .get(`/list-credentials${filter}`)
      .then((response) => {
        setCredentials(response.data.credentials);
        setCredentialsTotal(response.data.total);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <HeaderPublic />
      <div className="view">
        <h2>Credenciados</h2>
        <p
          style={{
            width: "70%",
            fontWeight: 400,
            marginTop: 10,
            marginBottom: 15,
            fontSize: 15,
          }}
        >
          Aqui você encontra nossos credenciados para te ajudar, usando os
          filtros abaixos você encontrará o mais proximo a sua região
        </p>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              flex: 1,
              marginRight: 20,
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                marginRight: 20,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h4
                style={{
                  marginTop: 10,
                  fontSize: 14,
                  color: "#666",
                  marginBottom: 5,
                }}
              >
                Estado
              </h4>
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                value={state || null}
                placeholder="Seleciona o estado"
                style={{
                  width: 200,
                }}
                onChange={(value) => {
                  setState(value);
                  setCity("");
                  setCities(
                    value
                      ? states.filter((item) => {
                          return item.sigla == value;
                        })[0].cidades
                      : [],
                  );
                }}
              >
                {states.map((item) => {
                  return (
                    <Select.Option value={item.sigla}>
                      {item.nome}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
            <div
              style={{
                marginRight: 20,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h4
                style={{
                  marginTop: 10,
                  fontSize: 14,
                  color: "#666",
                  marginBottom: 5,
                }}
              >
                Cidade
              </h4>
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                disabled={state == ""}
                value={city || null}
                placeholder="Seleciona a cidade"
                style={{
                  width: 200,
                }}
                onChange={(value) => {
                  setCity(value);
                }}
              >
                {cities?.map((item) => (
                  <Select.Option value={item}>{item}</Select.Option>
                ))}
              </Select>
            </div>
            <div
              style={{
                marginRight: 20,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h4
                style={{
                  marginTop: 10,
                  fontSize: 14,
                  color: "#666",
                  marginBottom: 5,
                }}
              >
                Serviço
              </h4>
              <Select
                value={service || null}
                allowClear
                placeholder="Seleciona o serviço"
                style={{
                  width: 200,
                }}
                onChange={(value) => {
                  setService(value);
                }}
              >
                <Select.Option value={"Treinamentos"}>
                  Treinamentos
                </Select.Option>
                <Select.Option value={"Visita Técnica"}>
                  Visita Técnica
                </Select.Option>
                <Select.Option value={"Medições ambientais"}>
                  Medições ambientais
                </Select.Option>
                <Select.Option value={"Elaboração de PGR, PCMSO LTCAT"}>
                  Elaboração de PGR, PCMSO LTCAT
                </Select.Option>
              </Select>
            </div>
            <Button
              type="primary"
              style={{ marginTop: 15 }}
              onClick={() => {
                let url = `/credentials`;
                if (state) {
                  if (url != `/credentials`) {
                    url = url + `&state=${state}`;
                  } else {
                    url = url + `?state=${state}`;
                  }
                  if (city) {
                    url = url + `&city=${city}`;
                  }
                }
                if (service) {
                  if (url != `/credentials`) {
                    url = url + `&service=${service}`;
                  } else {
                    url = url + `?service=${service}`;
                  }
                }
                navigate(url, { replace: true });
              }}
            >
              Buscar
            </Button>
          </div>
          <p style={{ margin: 0 }}>{credentialsTotal} Credenciados</p>
        </div>

        {loading ? (
          <Spin
            size="large"
            style={{
              marginTop: 100,
              width: "100%",
              justifySelf: "center",
            }}
          />
        ) : (
          <>
            <List>
              {credentials.length == 0 && (
                <Message>Nenhum credenciado encontrado</Message>
              )}
              {credentials.map((item) => {
                return (
                  <div style={{ maxWidth: 280 }}>
                    <div className="infos">
                      <p
                        style={{
                          flex: 1,
                          width: "auto",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {item.name}
                      </p>
                      <Button
                        color="primary"
                        variant="link"
                        style={{ marginLeft: 10, width: 65 }}
                        onClick={() => {
                          setCredential(item);
                          setVisibleModal(true);
                        }}
                      >
                        Detalhes
                      </Button>
                    </div>
                    <img src={item.photo ? item.photo_url : userPhoto} />

                    <div className="infos" style={{ flexDirection: "column" }}>
                      <p
                        style={{
                          textTransform: "capitalize",
                          fontSize: 12,
                          margin: "6px 0",
                          width: "100%",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {item.description}
                      </p>
                      <p
                        style={{
                          textTransform: "capitalize",
                          width: "100%",
                          fontSize: 15,
                        }}
                      >
                        {item.city} - {item.state}
                      </p>
                    </div>
                  </div>
                );
              })}
            </List>
            <Pagination
              style={{
                justifySelf: "center",
              }}
              defaultCurrent={page + 1}
              onChange={(page) => {
                let url = `/credentials`;
                if (state) {
                  if (url != `/credentials`) {
                    url = url + `&state=${state}`;
                  } else {
                    url = url + `?state=${state}`;
                  }
                  if (city) {
                    url = url + `&city=${city}`;
                  }
                }
                if (service) {
                  if (url != `/credentials`) {
                    url = url + `&service=${service}`;
                  } else {
                    url = url + `?service=${service}`;
                  }
                }
                if (url != `/credentials`) {
                  url = url + `&page=${page - 1}`;
                } else {
                  url = url + `?page=${page - 1}`;
                }
                navigate(url);
              }}
              total={credentialsTotal}
              pageSize={30}
              showTotal={(total) => `${total} credenciados`}
            />
          </>
        )}
      </div>

      <Modal
        title={"Franqueado"}
        width={500}
        open={visibleModal}
        okText={"FECHAR"}
        cancelButtonProps={{
          style: {
            display: "none",
          },
        }}
        cancelText="FECHAR"
        onOk={() => {
          setVisibleModal(false);
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "20px 0",
          }}
        >
          <img
            style={{
              width: 180,
              height: 180,
              borderRadius: 10,
              background: "#fff",
            }}
            src={credential?.photo_url ? credential?.photo_url : userPhoto}
          />
          <p
            style={{
              fontWeight: "600",
              fontSize: 20,
              textAlign: "center",
              marginTop: 15,
            }}
          >
            {credential.name}
          </p>
          <p
            style={{
              fontSize: 16,
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            {credential.email}
          </p>
          <p
            style={{
              fontSize: 16,
              fontWeight: "500",
              margin: "8px 0",
              textAlign: "center",
            }}
          >
            {credential.phone_number}
          </p>
          <p
            style={{
              fontWeight: "500",
              textTransform: "capitalize",
              fontSize: 16,
              textAlign: "center",
            }}
          >
            {credential.city} - {credential.state}
          </p>
          <p
            style={{
              fontSize: 15,
              marginTop: 8,
              textAlign: "center",
            }}
          >
            {credential.description}
          </p>
          <p
            style={{
              fontWeight: "600",
              fontSize: 16,
              margin: "8px 0",
              textAlign: "center",
            }}
          >
            Cidades Atendidas
          </p>

          <div
            style={{
              display: "flex",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {credential.served_cities?.split(";").map((item) => {
              if (item) {
                return (
                  <div
                    style={{
                      borderRadius: 5,
                      fontSize: 14,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "5px",
                      padding: "3px 8px",
                      background: "#f0f0f0",
                    }}
                  >
                    {item}
                  </div>
                );
              }
            })}
          </div>
          <p
            style={{
              fontWeight: "600",
              fontSize: 16,
              margin: "8px 0",
              textAlign: "center",
            }}
          >
            Serviços
          </p>
          <div
            style={{
              display: "flex",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {credential.services?.split(";").map((item) => {
              if (item) {
                return (
                  <div
                    style={{
                      borderRadius: 5,
                      fontSize: 14,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "5px",
                      padding: "3px 8px",
                      background: "#f0f0f0",
                    }}
                  >
                    {item}
                  </div>
                );
              }
            })}
          </div>
        </div>
      </Modal>
    </Container>
  );
}
